import * as BasketNS from './';

export interface IComponentDescriptor {
	readonly option : BasketNS.Option;
	readonly name : string;
	readonly reference : string | BasketNS.Reference.ISerialized | null;
	readonly sku : string | BasketNS.Reference.ISerialized | null;
	readonly gtin : string | BasketNS.Reference.ISerialized | null;
	readonly imageURL : string | null;
};

export interface IComponentSerialized {
	readonly name : string;
	readonly reference : BasketNS.Reference.ISerialized | null;
	readonly sku : BasketNS.Reference.ISerialized | null;
	readonly gtin : BasketNS.Reference.ISerialized | null;
	readonly imageURL : string | null;
};

export class Component {
	readonly option : BasketNS.Option;
	readonly name : string;
	readonly reference : BasketNS.Reference | null;
	readonly sku : BasketNS.Reference | null;
	readonly gtin : BasketNS.Reference | null;
	readonly imageURL : string | null;

	serialize() : IComponentSerialized {
		return (Object.assign(
			{
				name : this.name
			}, {
				reference : this.reference ? this.reference.serialize() : null,
				sku :       this.sku ? this.sku.serialize() : null,
				gtin :      this.gtin ? this.gtin.serialize() : null,
				imageURL :  this.imageURL || null
			}
		));
	};

	constructor(desc : IComponentDescriptor) {
		this.option = desc.option;
		this.name = desc.name;
		this.imageURL = desc.imageURL || null;
		this.reference = null;
		if (desc.reference) {
			if (typeof desc.reference === 'string') {
				this.reference = new BasketNS.Reference(desc.reference);
			} else {
				this.reference = new BasketNS.Reference(desc.reference.value);
			}
		}
		this.sku = null;
		if (desc.sku) {
			if (typeof desc.sku === 'string') {
				this.sku = new BasketNS.Reference(desc.sku);
			} else {
				this.sku = new BasketNS.Reference(desc.sku.value);
			}
		}
		this.gtin = null;
		if (desc.gtin) {
			if (typeof desc.gtin === 'string') {
				this.gtin = new BasketNS.Reference(desc.gtin);
			} else {
				this.gtin = new BasketNS.Reference(desc.gtin.value);
			}
		}
	};
};
